import React from 'react'
import Link from 'gatsby-link'

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark
  return (
    <article className="documentation">
      <h1>
        <Link to={frontmatter.link}>{frontmatter.title}</Link>
      </h1>
      <h2>Updated: {frontmatter.date}</h2>
      <div
        className="documentation-md"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </article>
  )
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/docTemplate.jsx